export function disconnectConnection({ commit }) {
  commit('disconnectConnection')
}
export function disconnectChatConnection({ commit }) {
  commit('disconnectChatConnection')
}
export function updateConnection({ commit }, payload) {
  commit('updateConnection', payload)
}
export function updateChatConnection({ commit }, payload) {
  commit('updateChatConnection', payload)
}
export function updateConnecting({ commit }, payload) {
  commit('updateConnecting', payload)
}
export function updateConnected({ commit }, payload) {
  commit('updateConnected', payload)
}
export function setUnreadChatCount({ commit }, payload) {
  commit('setUnreadChatCount', payload)
}
export function incrementUnreadChatCount({ commit }, payload) {
  commit('incrementUnreadChatCount', payload)
}
